import React from 'react';
import { motion } from 'framer-motion';
import { Trophy, Music, Palette, Users, BookOpen, Globe } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader';

const CollegeExtracurriculars = () => {
  const activities = [
    {
      category: 'Sports',
      icon: Trophy,
      items: ['Football', 'Basketball', 'Athletics', 'Table Tennis', 'Swimming'],
      image: 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=600&h=400&fit=crop',
    },
    {
      category: 'Arts & Culture',
      icon: Palette,
      items: ['Drama Club', 'Fine Arts', 'Cultural Dance', 'Choir', 'Creative Writing'],
      image: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=600&h=400&fit=crop',
    },
    {
      category: 'Clubs & Societies',
      icon: Users,
      items: ['Debate Club', 'Press Club', 'Science Club', 'Literary Society', 'Red Cross'],
      image: 'https://images.unsplash.com/photo-1529390079861-591de354faf5?w=600&h=400&fit=crop',
    },
    {
      category: 'Leadership',
      icon: Globe,
      items: ['Student Council', 'Prefect Body', 'House Captains', 'Peer Mentoring', 'Community Service'],
      image: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?w=600&h=400&fit=crop',
    },
  ];

  return (
    <>
      <PageHeader
        title="Extracurriculars"
        subtitle="Developing well-rounded individuals beyond the classroom"
        breadcrumbs={[
          { label: 'Our Schools', href: '/our-schools' },
          { label: 'College', href: '/college' },
          { label: 'Extracurriculars' },
        ]}
      />

      <section className="section-padding bg-white">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-3xl mx-auto text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-6">
              Beyond Academics
            </h2>
            <p className="text-lg text-gray-600">
              We believe in developing the whole person. Our extracurricular programs
              help students discover their passions and develop leadership skills.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {activities.map((activity, index) => {
              const Icon = activity.icon;
              return (
                <motion.div
                  key={activity.category}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gray-50 rounded-2xl overflow-hidden"
                >
                  <div className="h-48 overflow-hidden">
                    <img
                      src={activity.image}
                      alt={activity.category}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center">
                        <Icon className="text-primary-600" size={20} />
                      </div>
                      <h3 className="text-xl font-bold text-gray-900">{activity.category}</h3>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {activity.items.map((item) => (
                        <span key={item} className="px-3 py-1 bg-white rounded-full text-sm text-gray-600 shadow-soft">
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default CollegeExtracurriculars;
